$(document).ready(function(){
	if($('.label-radio').hasClass('is-active')){
		$('.label-radio').parents('.catalog-tabs').addClass('catalog-tabs__height');
	}
	$('.header-nav__link').on('click', function(event) {
		event.preventDefault();
		var id  = $(this).attr('href');

		document.location.href="" + id + "";


	});
	// Select
	$(document).on("click", "[data-toggle='select']", function (e) {
		$(this).next().addClass('is-open');
		e.preventDefault();
		e.stopPropagation();
	});

	$("html, body").click(function (e) {
		$(".is-open").each(function () {
			if (!this.contains(e.target) && (this !== e.target) && !e.target.closest('.dropdown')) {
				$(this).removeClass("is-open");
			}
		});
	});

	$(document).on('click', '.dropdown-item', function () {
		$(".is-open").removeClass("is-open");
		var $this = $(this);
		var $modal = $this.closest(".select");
		$modal.find('.select-btn span').text($this.text());
	});

	// Reviews
	var reviewSlider = new Swiper('.reviews-slider', {
		loop: true,
		navigation: {
			nextEl: '.reviews-btn__next',
			prevEl: '.reviews-btn__prev',
		},
	});

	// Catalog filter slider
	var catalogFilter = new Swiper('.catalog-filter__slider', {
		slidesPerView: 5,
		spaceBetween: 30,
		simulateTouch: false,
		navigation: {
			nextEl: '.catalog-filter__slider .slider-arrow__next',
			prevEl: '.catalog-filter__slider .slider-arrow__prev',
		},
		breakpoints: {
			1199: {
				slidesPerView: 4,
				simulateTouch: true,
				loop: true
			},
			991: {
				slidesPerView: 3,
				simulateTouch: true,
				loop: true
			},
			767: {
				slidesPerView: 2,
				simulateTouch: true,
				loop: true
			},
			575: {
				slidesPerView: 1,
				simulateTouch: true,
				loop: true
			},
		},
	});

	// Popup Fancybox
	$('[data-fancybox]').fancybox({
		touch : false,
		animationDuration : 150,
		animationEffect   : 'slide-in-out'
	});
	$.fancybox.defaults.closeExisting=true;

	// Scroll Top
	$(window).scroll(function(){
		if ($(window).scrollTop() >= 350) {
			$(".scroll-top").show();
		}
		else{
			$(".scroll-top").hide();
		}
	});

	// Fixed Cart
	if($(window).width() > 991){
		$(window).scroll(function(){
			if ($(window).scrollTop() >= 350) {
				$(".header-cart").addClass('is-fixed');
			}
			else{
				$(".header-cart").removeClass('is-fixed');
			}
		});
	}


    //// Phone Mask
    //var phoneMask = function () {
    //    //$('input[type="tel"]').inputmask("+380 (99) 999 9999", {insertMode:false});
    //    $('input[type="tel"]').mask('+380 dd ddd dddd', {
    //        translation: {
    //            'd': {pattern: /\d/},
    //            '0': {pattern: /0/},
    //            //'9': {pattern: /\d/, optional: true},
    //            //'#': {pattern: /\d/, recursive: true},
    //            //'A': {pattern: /[a-zA-Z0-9]/},
    //            //'S': {pattern: /[a-zA-Z]/},
    //        },
    //        placeholder: "+380 (__) ___ ____"
    //    });
    //};
    //phoneMask();

	$(".scroll-top").click(function() {
		$("html, body").animate({
			scrollTop: 0
		}, 300);
	});

	// Mobile Menu
	$('.mobile-burger').on('click', function () {
		$('.mobile-menu').toggleClass('is-show');
	});

	$('.mobile-menu__item .header-nav__link').on('click', function () {
		$('.mobile-menu').removeClass('is-show');
	});

    // Countdown
    var countdown = $('#countdown');
    if (countdown.length > 0) {
        function time(timeend) {
            var update_interval = 24;
            var now = new Date();
            var today = new Date();
            today = Math.floor((timeend - today) / 1000);

            if (timeend < now) {
                var N = Math.ceil((now - timeend) / (60 * 60 * 1000 * update_interval));
                timeend.setTime(timeend.getTime() + N * update_interval * 60 * 60 * 1000);
            }

            var tsec = today % 60;
            today = Math.floor(today / 60);
            var tmin = today % 60;
            today = Math.floor(today / 60);
            var thour = today % 24;
            today = Math.floor(today / 24);

            if (thour < 10) {
                thour = "0" + thour;
            }

            if (tmin < 10) {
                tmin = "0" + tmin;
            }

            if (tsec < 10) {
                tsec = "0" + tsec;
            }

            document.querySelector('.days').innerHTML = today;
            document.querySelector('.hours').innerHTML = thour;
            document.querySelector('.minutes').innerHTML = tmin;
            document.querySelector('.seconds').innerHTML = tsec;
            return thour + ':' + tmin + ':' + tsec;
        }
        function startTimer() {
            var action_date = new Date();
            action_date.setTime(countdown.data('end') * 1000);
            var timeend = new Date(action_date);
            var now = new Date();
            var update_interval = 24;
            if (timeend < now) {
                var N = Math.ceil((now - timeend) / (60 * 60 * 1000 * update_interval));
                timeend.setTime(timeend.getTime() + N * update_interval * 60 * 60 * 1000);
            }
            time(timeend);
            setInterval(function () {
                time(timeend);
            }, 1000);
        }

        var start_date = new Date();
        start_date.setTime(countdown.data('start') * 1000);
        var now = new Date();
        if (now > start_date) {
            $('.middle-env__countdown').show();
            startTimer();
        }
    }
}); //end
$(document).on('click', '.label-radio', function () {
	var $this =  $(this);
	if($this.next().length > 0){
		$this.parents('.catalog-tabs').addClass('catalog-tabs__height');
	}

});